export default __webpack_public_path__ + "static/media/02_oplocenka_PetraK-min.b952088f.jpg";